import { HttpParams } from '@angular/common/http';
import { toIsoDate } from '@shared/utils/date';
import { GetStockHistoryValue } from './get-stock-history.value';

export class GetStockHistoryValueDto {
    page: number;
    limit: number;
    dateFrom: string | null;
    dateTo: string | null;
    employeeId: string | null;
    materialId: string | null;

    constructor(data: GetStockHistoryValue) {
        this.page = data.page;
        this.limit = data.limit;
        this.dateFrom = data.dateFrom && toIsoDate(data.dateFrom);
        this.dateTo = data.dateTo && toIsoDate(data.dateTo);
        this.employeeId = data.employeeId;
        this.materialId = data.materialId;
    }

    // Only the filters that are set go out; with no dates the backend returns today, and a single date leaves the other side open.
    toHttpParams(): HttpParams {
        const filters = { dateFrom: this.dateFrom, dateTo: this.dateTo, employeeId: this.employeeId, materialId: this.materialId };

        return Object.entries(filters).reduce(
            (params, [key, value]) => (value ? params.set(key, value) : params),
            new HttpParams().set('page', this.page).set('limit', this.limit),
        );
    }
}
